import axios from 'axios';
/** 统一信用代码校验 */
export const checkOrgnizationCode = (code, companyName, msgCallBack) => {
  return new Promise((resolve, reject) => {
    if (!companyName && !code) {
      resolve(true)
    } else {
      axios.get(`/shared-base-data/basic/v1/company/credit?companyName=${companyName}`).then(({ data }) => {
        if (data && data.name !== companyName) {
          msgCallBack('请输入正确的公司名称', 'warning');
          resolve(false)
        } else if (data && data.creditCode !== code) {
          msgCallBack('请输入正确的统一信用代码', 'warning');
          resolve(false)
        } else {
          resolve(true)
        }
      }, err => {
        msgCallBack('未知错误', 'warning');
        reject()
      }).catch(() => {
        msgCallBack('未知错误', 'warning');
        reject()
      })
    }
  })
}
/** 不允许输入空格 */
export const replaceSpaces = (val) => {
  const strVal = `${val}`
  return strVal.replace(/\s/g, '')
}
export function replaceAll(originalValue, reg = /[X0-9]/g) {
  const arr = originalValue.match(reg);
  return arr ? arr.join('') : '';
}
/** 是否是全角 false 不满足条件 */
export const isFullAngle = (val) => {
  const strVal = `${val}`
  if (strVal.includes('(') || strVal.includes(')')) {
    return false
  }
  return true
}
export const companyErrorFields = {
  'companyareaid': {
    name: '公司所在地',
    event: 'select'
  },
  supplierName: {
    name: '公司名称',
    event: 'input'
  },
  'companysendareaids': {
    name: '供货区域',
    event: 'select'
  },
  registerCapital: {
    name: '注册资金',
    event: 'input'
  },
  // orgnizationCode
  orgnizationCode: {
    name: '统一信用代码/组织机构代码',
    event: 'input'
  },
  'address': {
    name: '公司详细地址',
    event: 'input'
  },
  'representative': {
    name: '法人姓名',
    event: 'input'
  },
  'taxpayerType': {
    name: '纳税人类型',
    event: 'select'
  },
  currency: {
    name: '币种',
    event: 'select'
  },
  'email': {
    name: '邮箱',
    event: 'input'
    // '邮箱'
  },
  'bankNumber': {
    name: '银行账号',
    event: 'input'
  },
  'openBankName': {
    name: '开户行名称',
    event: 'input'
  },
  'taxPayerRate': {
    name: '纳税人税率',
    event: 'select'
  },
  'contactPerson': {
    name: '公司联系人',
    event: 'input'
  },
  'mobile': {
    name: '联系人电话',
    event: 'input'
  },
  verificationCode:{
    name:'手机验证码',
    event:'input'
  },
  'unionPayNumber': {
    name: '开户行联行号',
    event: 'input'
  },
  'openBankAddress': {
    name: '开户银行地址',
    event: 'input'
  },
  'businesslicense': {
    name: '税务登记号',
    event: 'input'
  },
  'idCard': {
    name: '法人身份证号',
    event: 'input'
  },
  'primarybusiness': {
    name: '主营业务',
    event: 'input'
  },
  'introduction': {
    name: '企业简介',
    event: 'input'
  },
  'listedCompany': {
    name: '是否上市公司',
    event: 'select'
  },
  'countryId': {
    name: '公司所在国家',
    event: 'select'
  },
  'buildTime': {
    name: '成立日期',
    event: 'select'
  },
  'industryId': {
    name: '所属行业',
    event: 'select'
  },
  'taxTypeId': {
    name: '税种',
    event: 'select'
  },
  'claEconomicId': {
    name: '经济类型',
    event: 'select'
  },
  'accountTypeId': {
    name: '银行账户类型',
    event: 'select'
  },
  property: {
    name: '单位性质',
    event: 'select'
  },
  'accountName': {
    name: '开户名',
    event: 'input'
  },
  'currencyId': {
    name: '银行账户币种',
    event: 'select'
  },
  'invoiceAddr': {
    name: '发票地址',
    event: 'input'
  },
  'invoicePhone': {
    name: '发票通讯电话',
    event: 'input'
  },
  'invoicePayNumber': {
    name: '发票开户银行联行号',
    event: 'input'
  },
  'invoiceBankName': {
    name: '发票开户银行名称',
    event: 'input'
  },
  'invoiceBankNumber': {
    name: '发票开户账号',
    event: 'input'
  },
  'representativeTel': {
    name: '法人电话',
    event: 'input'
  },
  typeName: {
    name: '企业类型',
    event: 'select'
  },
  companyMobile: {
    name: '联系人电话',
    event: 'input'
  },
  taxType: {
    name: '纳税人税率',
    event: 'select'
  },
  idcardfront:{
    name:'身份证正面',
    event: 'select'
  },
  idcardback:{
    name:'身份证反面',
    event: 'select'
  }
}
/** 
 * @param {Promise<AxiosResponse<any,any>>} severFn
 * @param {number} count
 * @return {Promise<AxiosResponse<any, any>>}
 */
 export function requestTry(severFn, count = 3) { // times是重试次数
  return new Promise((resolve, reject) => {
    function reTryFunc(times) {
      severFn.then((res) => {
        resolve(res);
      }).catch((err) => {
        if (times > 0) {
          setTimeout(() => {
            reTryFunc(times - 1);
          });
        } else {
          reject(err);
        }
      });
    }
    reTryFunc(count);
  });
}
/** 公司联系人必填字段 */
export const companyContractPersonRequiredFields = ['supplierName', 'orgnizationCode', 'mobile', 'verificationCode', 'realName', 'password', 'comfirmPassword', 'email']
/** 公司及法人信息必填字段 */
export const companyLegalPersonRequiredFields = [
  'supplierName',
  'property',
  'registerCapital',
  'typeName',
  'orgnizationCode',
  'businesslicense',
  'companysendareaids',
  'companyareaid',
  'address',
  'contactPerson',
  'mobile',
  'taxpayerType',
  'taxType',
  'taxTypeId',
  'openBankName',
  'openBankAddress',
  'bankNumber',
  'unionPayNumber',
  'listedCompany',
  'countryId',
  'buildTime',
  'industryId',
  'claEconomicId',
  'accountTypeId',
  'accountName',
  'currencyId',
  'representative',
  'idCard',
  'representativeTel',
  'invoiceAddr',
  'invoicePhone',
  'invoicePayNumber',
  'invoiceBankName',
  'invoiceBankNumber',
  'idcardfront',
  'idcardback',
  'primarybusiness',
  'introduction',
]
